<div id="app-layout">
  <app-topbar />
  <app-sidebar />

  <div class="content-page">
    <div class="content">
      <!-- Start Content-->
      <div class="container-fluid">
        <router-outlet />
      </div>
    </div>
  </div>

  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col fs-13 text-muted text-center">
          &copy;
          {{ year }} - Made by
          <a href="https://www.octoplusit.com" class="text-primary fw-semibold" target="_blank">{{ name }}</a>
        </div>
      </div>
    </div>
  </footer>
</div>
